import _ from "lodash";
import $ from "jquery";
import moment from "moment";
import { useState, useEffect, useLayoutEffect } from "react";
import ReactDatePicker from "react-datepicker";
import { DropdownItemProps, Segment, Form, Dropdown, Divider, Input, Button, Table, Modal, Sidebar, Menu, Icon, FormProps, Select, Label, Message } from "semantic-ui-react";
import { ModalControlData, useModalControl, useRequest } from "../../hooks/commonHooks";
import { useFormConnect, useFormData } from "../../hooks/formHooks";
import { restRequest } from "../../http";
import { PageData } from "../../models/common_model";
import { DropdownOption, TestingFile } from "../../models/testing_model";
import { fieldError, formatDateTime } from "../../utils";
import { Page } from "../commons/Page";
import { TestingFileComponent } from "./TestingFile";
import { notificationControl } from "../../controls/notification-control";
import { FileStatusMark } from "./StatusMark";
import { dialogControl } from "../../controls/dialog-control";
const downloadCsv = require('download-csv') as any;

export function AllTestingFiles(props: {}) {
    const [searchData, setSearchField] = useFormData({ product: '', station: '', order: '', sequence_status: '', update_status: '', start_time: undefined, end_time: undefined, file_name: '', pass_measurement: '', fail_measurement: '', invalid_measurement: '', never_pass: -1, stock_in: -1 });
    const [testFilePage, setSearchData, searchLoading] = useFormConnect<any, PageData<TestingFile>>({ page_size: 30 }, `testings/files/search`, 'post', parameters => {
        return {
            ...parameters, start_time: parameters.start_time ? moment(parameters.start_time).format('YYYY-MM-DD HH:mm:ss') : undefined,
            end_time: parameters.end_time ? moment(parameters.end_time).format('YYYY-MM-DD HH:mm:ss') : undefined,
        }
    });
    const [testingResultDropdownOptions, setTestingResultDropdownOptions] = useState<DropdownOption[]>([]);
    const [productOptions, setProductOptions] = useState<DropdownItemProps[]>([]);
    const [stationOptions, setStationOptions] = useState<DropdownItemProps[]>([]);
    const [orderOptions, setOrderOptions] = useState<DropdownItemProps[]>([]);

    const [selectedIndexAfterLoaded, setSelectedIndexAfterLoad] = useState(0);

    const detailModalControl = useModalControl<TestingFile>();

    const [height, setHeight] = useState('auto');
    const [contentHeight, setContentHeight] = useState('auto');

    useEffect(() => {
        restRequest<DropdownOption[]>('svn_repository/result_dropdown_options').then(setTestingResultDropdownOptions)
    }, []);


    useEffect(() => {
        const options = [{ key: '', text: 'All', value: '' }, ...testingResultDropdownOptions.map(t => ({ key: t.name, text: t.name, value: t.name }))];
        setProductOptions(options);
        if (!options.find(o => o.value == searchData.product)) {
            setSearchField(null, { name: 'product', value: '' });
            setSearchField(null, { name: 'station', value: '' });
            setSearchField(null, { name: 'order', value: '' });
        }
    }, [testingResultDropdownOptions]);

    useEffect(() => {
        const product = testingResultDropdownOptions.find(t => t.name == searchData.product);
        let options: DropdownItemProps[];
        if (product) {
            options = [{ key: '', text: 'All', value: '' }, ...product.children.map(t => ({ key: t.name, text: t.name, value: t.name }))];
        } else {
            options = [{ key: '', text: 'All', value: '' }];
        }

        setOrderOptions(options);

        if (!options.find(o => o.value == searchData.station)) {
            setSearchField(null, { name: 'station', value: '' });
            setSearchField(null, { name: 'order', value: '' });
        }
    }, [testingResultDropdownOptions, searchData.product]);

    useEffect(() => {
        let options: DropdownItemProps[] = [{ key: '', text: 'All', value: '' }];
        const product = testingResultDropdownOptions.find(t => t.name == searchData.product);
        if (product) {
            const station = product.children.find(s => s.name == searchData.order);
            if (station) {
                options = [{ key: '', text: 'All', value: '' }, ...station.children.map(t => ({ key: t.name, text: t.name, value: t.name }))];
            }
        }

        setStationOptions(options);

        if (!options.find(o => o.value == searchData.order)) {
            setSearchField(null, { name: 'station', value: '' });
        }
    }, [testingResultDropdownOptions, searchData.product, searchData.order]);

    useEffect(() => {
        const onScrollSelected = (moveIndex: number) => {
            if (testFilePage && detailModalControl.data) {
                const currentIndex = testFilePage.items.indexOf(detailModalControl.data);
                let newIndex;
                if (currentIndex === -1) {
                    if (moveIndex === -1) {
                        newIndex = testFilePage.items.length - 1;
                    } else {
                        newIndex = 0;
                    }
                } else {
                    newIndex = currentIndex + moveIndex;
                    if (newIndex < 0) {
                        if (testFilePage.number > 1) {
                            setSearchData((p: any) => ({ ...p, page_number: testFilePage.number - 1 }));
                            setSelectedIndexAfterLoad(-1);
                        } else {
                            return;
                        }
                    } else if (newIndex >= testFilePage.items.length) {
                        if (testFilePage.number < testFilePage.pages) {
                            setSearchData((p: any) => ({ ...p, page_number: testFilePage.number + 1 }));
                            setSelectedIndexAfterLoad(1);
                        } else {
                            return;
                        }
                    }
                }

                detailModalControl.data = testFilePage.items[newIndex];
            }
        }

        /*
        arrow left：37
        arrow up：38
        arrow right：39
        arrow down：40
        */
        const onKey = (e: JQuery.KeyDownEvent) => {
            if (e.keyCode == 38) {
                // arrow up
                onScrollSelected(-1);
            } else if (e.keyCode == 40) {
                // arrow down
                onScrollSelected(1);
            }
        }

        $(document).on('keydown', onKey);

        return () => {
            $(document).off('keydown', onKey);
        }
    }, [detailModalControl.data, testFilePage]);

    useEffect(() => {
        if (testFilePage && selectedIndexAfterLoaded !== 0) {
            if (selectedIndexAfterLoaded === -1) {
                detailModalControl.data = _.last(testFilePage.items);
            } else {
                detailModalControl.data = testFilePage.items[0];
            }
            setSelectedIndexAfterLoad(0);
        }
    }, [testFilePage]);

    useLayoutEffect(() => {
        const onResize = function () {
            const $root = $('#allTestingFilesRoot');
            setHeight(window.innerHeight - ($root.offset()?.top || 100) - 20 + 'px');
            const $content = $('#testingFilesContent');
            setContentHeight(window.innerHeight - ($content.offset()?.top || 0) - 20 + 'px');
        };

        $(window).on('resize', onResize);
        onResize();

        return function () {
            $(window).off('resize', onResize);;
        }
    }, []);


    return <>
        <Sidebar.Pushable as={Segment} id="allTestingFilesRoot" style={{ height, overflow: 'hidden' }}>
            <Sidebar
                style={{ width: 'calc(100% - 10rem)', height: '100%', backgroundColor: '#fff' }}
                animation='overlay'
                direction="right"
                onHide={() => detailModalControl.setOpen(false)}
                visible={detailModalControl.props.open}
            >
                {detailModalControl.data && detailModalControl.props.open && <TestingFileComponent height={window.innerHeight - 30} file={detailModalControl.data} isSinglePage={false} />}
            </Sidebar>

            <Sidebar.Pusher>
                <Segment.Group>
                    <Segment attached="top">
                        <Form onSubmit={e => setSearchData(searchData)} size="mini" className="list-search" loading={searchLoading}>
                            <Form.Group>
                                <Form.Input inline label="Product" style={{ minWidth: '10rem' }}>
                                    <Dropdown name="product" value={searchData.product || ''} onChange={setSearchField} options={productOptions} search selection fluid></Dropdown>
                                </Form.Input>

                                <Form.Input label="Build" inline style={{ minWidth: '3rem' }}>
                                    <Dropdown name="order" value={searchData.order || ''} onChange={setSearchField} options={orderOptions} search selection fluid></Dropdown>
                                </Form.Input>

                                <Form.Input label="Station" inline style={{ minWidth: '10rem' }}>
                                    <Dropdown name="station" value={searchData.station || ''} onChange={setSearchField} options={stationOptions} search selection fluid></Dropdown>
                                </Form.Input>

                                <Form.Input label="Sequence Status" inline style={{ minWidth: '10rem' }}>
                                    <Dropdown name="sequence_status" value={searchData.sequence_status || ''} onChange={setSearchField} options={[{ key: 0, text: 'All', value: '' }, { key: 1, text: 'Pass', value: 1 }, { key: 2, text: 'Fail', value: 2 }, { key: 3, text: 'Invalid', value: 3 }, { key: 4, text: 'Stopped', value: 4 }]} search selection fluid></Dropdown>
                                </Form.Input>

                                <Form.Input label="Update Status" inline style={{ minWidth: '10rem' }}>
                                    <Dropdown name="update_status" value={searchData.update_status || ''} onChange={setSearchField} options={[{ key: 0, text: 'All', value: '' }, { key: 1, text: 'Pass', value: 1 }, { key: 2, text: 'Fail', value: 2 }]} search selection fluid></Dropdown>
                                </Form.Input>

                                <Form.Input inline className="date" label="Datetime">
                                    <table cellPadding={0} cellSpacing={0}>
                                        <tr>
                                            <td>
                                                <ReactDatePicker showTimeSelect
                                                    placeholderText="From"
                                                    dateFormat="yyyy-MM-d HH:mm"
                                                    timeFormat="HH:mm"
                                                    selected={searchData.start_time} onChange={(value: Date) => setSearchField(null, { name: 'start_time', value })}></ReactDatePicker>
                                            </td>
                                            <th style={{ padding: '0 3px' }}> - </th>
                                            <td>
                                                <ReactDatePicker showTimeSelect
                                                    placeholderText="To"
                                                    dateFormat="yyyy-MM-d HH:mm"
                                                    timeFormat="HH:mm"
                                                    minDate={searchData.start_time}
                                                    selected={searchData.end_time} onChange={(value: Date) => setSearchField(null, { name: 'end_time', value })}></ReactDatePicker>
                                            </td>
                                        </tr>
                                    </table>
                                </Form.Input>

                                <Form.Input label="Never Pass Some Stations" inline style={{ minWidth: '10rem' }}>
                                    <Dropdown name="never_pass" value={searchData.never_pass} onChange={setSearchField} options={[{ key: 0, text: 'All', value: -1 }, { key: 1, text: 'Yes', value: 1 }, { key: 2, text: 'No', value: 2 }]} selection fluid></Dropdown>
                                </Form.Input>
                            </Form.Group>
                            <Divider />
                            <Form.Group>
                                <Form.Field inline>
                                    <Input placeholder="Serials or File Name" name="file_name" value={searchData.file_name || ''} onChange={(e, d) => setSearchField(null, {name: e.target.name, value: d.value.trim()})} />
                                </Form.Field>
                                <Form.Field inline>
                                    <Input placeholder="Pass Measurement" name="pass_measurement" value={searchData.pass_measurement || ''} onChange={setSearchField} />
                                </Form.Field>
                                <Form.Field inline>
                                    <Input placeholder="Fail Measurement" name="fail_measurement" value={searchData.fail_measurement || ''} onChange={setSearchField} />
                                </Form.Field>
                                <Form.Field inline>
                                    <Input placeholder="Invalid Measurement" name="invalid_measurement" value={searchData.invalid_measurement || ''} onChange={setSearchField} />
                                </Form.Field>
                                <Form.Input label="Stock In" inline style={{ minWidth: '10rem' }}>
                                    <Dropdown name="stock_in" value={searchData.stock_in} onChange={setSearchField} options={[{ key: 0, text: 'All', value: -1 }, { key: 1, text: 'Yes', value: 1 }, { key: 2, text: 'No', value: 2 }]} selection fluid></Dropdown>
                                </Form.Input>

                                <div>
                                    <Button icon="search" type="submit" size="mini"></Button>
                                </div>
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment attached="bottom" id="testingFilesContent" style={{ height: contentHeight, overflow: 'auto' }}>
                        <Table selectable>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Product</Table.HeaderCell>
                                    <Table.HeaderCell>Build</Table.HeaderCell>
                                    <Table.HeaderCell>Station</Table.HeaderCell>
                                    <Table.HeaderCell>File</Table.HeaderCell>
                                    <Table.HeaderCell>Date</Table.HeaderCell>
                                    <Table.HeaderCell>Sequence Status</Table.HeaderCell>
                                    <Table.HeaderCell>Fail Measurements</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {testFilePage?.items.map((s, i) => {
                                    return <Table.Row key={s.id} active={detailModalControl.data === s} onClick={(e: any) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (detailModalControl.data === s) {
                                            detailModalControl.data = undefined;
                                            detailModalControl.setOpen(false);
                                        } else {
                                            detailModalControl.data = s;
                                            detailModalControl.setOpen(true);
                                        }
                                    }}>
                                        <Table.Cell>{s.product}</Table.Cell>
                                        <Table.Cell>{s.order}</Table.Cell>
                                        <Table.Cell>{s.testing_station_name}</Table.Cell>
                                        <Table.Cell title={s.file_path}>{_.last(s.file_path.split('/'))}</Table.Cell>
                                        <Table.Cell>{formatDateTime(s.date, true)}</Table.Cell>
                                        <Table.Cell><FileStatusMark status={s.status} /></Table.Cell>
                                        <Table.Cell>{s.fail_measurements}</Table.Cell>

                                    </Table.Row>
                                })}
                            </Table.Body>
                        </Table>
                        <Page data={testFilePage} updatePage={setSearchData}></Page>
                    </Segment>
                </Segment.Group>
            </Sidebar.Pusher>
        </Sidebar.Pushable>
    </>
}